<template>
  <v-container fluid class="sale-performance-mini pa-2">
    <v-alert v-if="errorMessage" type="error" text dense class="rounded-lg mb-3">
      <div class="d-flex flex-wrap align-center justify-space-between">
        <span>{{ errorMessage }}</span>
        <v-btn text color="error" @click="loadData">Retry</v-btn>
      </div>
    </v-alert>
    <v-list class="sale-performance-mini__list rounded-xl py-0">
      <!-- Income -->
      <v-list-item class="sale-performance-mini__row px-3">
        <v-list-item-avatar color="primary" class="sale-performance-mini__icon" size="34">
          <v-icon dark small>mdi-cash-multiple</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Income</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right" v-else>{{ income | currency }}</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Card -->
      <v-list-item class="sale-performance-mini__row px-3">
        <v-list-item-avatar color="primary" class="sale-performance-mini__icon" size="34">
          <v-icon dark small>mdi-credit-card-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Card</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right" v-else>{{ cardAmount | currency }}</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Other Payments -->
      <v-list-item class="sale-performance-mini__row px-3">
        <v-list-item-avatar color="primary" class="sale-performance-mini__icon" size="34">
          <v-icon dark small>mdi-wallet-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Other Payments</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right" v-else>{{
            otherPayment | currency
          }}</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Cash -->
      <v-list-item class="sale-performance-mini__row px-3">
        <v-list-item-avatar color="success" class="sale-performance-mini__icon" size="34">
          <v-icon dark small>mdi-cash</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Cash</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right" v-else>{{ cashAmount | currency }}</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Expense -->
      <v-list-item @click="expenseReport('expense')" class="sale-performance-mini__row cursor-pointer px-3">
        <v-list-item-avatar color="error" class="sale-performance-mini__icon" size="34">
          <v-icon dark small>mdi-receipt-text-minus-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Expense</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            color="red"
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right" v-else>{{ expense | currency }}</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Cash In Hand -->
      <v-list-item class="sale-performance-mini__row px-3">
        <v-list-item-avatar color="primary" class="sale-performance-mini__icon" size="34">
          <v-icon dark small>mdi-safe-square-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Cash In Hand
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right font-weight-bold" v-else>
            {{ cashInHand | currency }}
          </span>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import locationService from "@/modules/Location/service.js";

export default {
  name: "SaleBaseTileMini",
  props: ["dateTime", "id"],
  data() {
    return {
      isLoading: true,
      openInvoice: 0,
      Revenue: 0,
      Discounts: 0,
      InvoiceCount: 0,
      customerCount: 0,
      NetSales: 0,
      expense: 0,
      NetProfit: 0,
      income: 0,
      TaxCollected: 0,
      cashAmount: 0,
      cardAmount: 0,
      otherPayment: 0,
      cashInHand: 0,
      errorMessage: "",
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    dateTime() {
      this.loadData();
    },
  },
  methods: {
    expenseReport() {
      const routeData = this.$router.resolve({
        path: `/reports/expenses?start=${this.dateTime.start}&end=${this.dateTime.end}&type=noExternalPayments&locationId=${this.id}`,
      });
      window.open(routeData.href, "_blank");
      window.postMessage({
        action: "OPENREPORT",
        data: routeData.href,
      });
    },
    loadData() {
      this.isLoading = true;
      this.errorMessage = "";
      locationService.Reports.getLocationSales({
        start: this.dateTime.start,
        end: this.dateTime.end,
        LocationId: this.id,
      })
        .then((response) => {
          const d = response.data;
          const amount = (value) => {
            const parsed = parseFloat(value);
            return Number.isFinite(parsed) ? parsed : 0;
          };
          this.Revenue = amount(d.revenue);
          this.InvoiceCount = d.invoiceCount;
          this.Discounts = amount(d.discounts);
          this.NetSales = amount(d.netSales);
          this.NetProfit = amount(d.netProfit);
          this.TaxCollected = amount(d.taxCollected);
          this.cashAmount = amount(d.cashAmount);
          this.otherPayment = amount(d.otherPaymentAmount);
          this.customerCount = amount(d.customerCount);
          this.expense = amount(d.expense);
          this.cardAmount = amount(d.creditCardAmount) + amount(d.debitCardAmount);
          this.income = this.otherPayment + this.cashAmount + this.cardAmount;
          this.cashInHand = this.cashAmount - this.expense;
          this.openInvoice = d.openInvoice;
        })
        .catch((error) => {
          console.error("Error loading location sales", error);
          this.errorMessage = "Performance data could not be loaded.";
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    nFormatter(num, digits) {
      const si = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      let i = si.length - 1;
      while (i > 0 && num < si[i].value) i--;
      return (
        (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol
      );
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.sale-performance-mini__row { min-height: 46px; }
.sale-performance-mini__icon { margin-right: 12px; }
.sale-performance-mini__row .v-list-item__action { margin: 8px 0; }
</style>
